// extracted by mini-css-extract-plugin
module.exports = {"buttonbar":"ShipmentPackagesTrackingList_buttonbar__3ckUx","spacer":"ShipmentPackagesTrackingList_spacer__3166V"};